import React, { useState } from 'react';
import { Spin, message } from 'antd';
import UserList from '../molecules/UserList';
import { updateUser } from '../../api/UsersContainer';
import { useAuth } from '../../context/AuthContext';
import { insertFirstAppover, checkFirstApproverExist, deleteFirstApprover } from '../../api/firstApproversContainer';

const User = () => {
    const [loading, setLoading] = useState(false);
    const { role } = useAuth();

    const handleRoleChange = async (id, role, name, email) => {
        setLoading(true);
        await updateUser(id, role);

        if (role === 'First Approver') {
            const exist = await checkFirstApproverExist(email);

            if (!exist) {
                await insertFirstAppover({ email: email, controller: name });
            }

        }
        else {
            const exist = await checkFirstApproverExist(email);

            if (exist) {
                await deleteFirstApprover(email);
            }
        }

        message.success('User role updated successfully');
        setLoading(false);
    }


    if (loading) {
        return <Spin
            size="large"
            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flex: 1, marginTop: -100 }}
        />;
    }

    return (
        <div className="management-page">
            {loading && <Spin size='large' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flex: 1, marginTop: -100 }} />}
            <div className="page-heading-row">
                <div className="page-heading-copy">
                    <span className="page-kicker">Access</span>
                    <h1>Users</h1>
                    <p>Review application users and update their access role.</p>
                </div>
            </div>
            {role === 'Admin' && (
                <section className="management-list-card full-width">
                    <UserList handleRoleChange={handleRoleChange} />
                </section>
            )}
        </div>
    );
};

export default User;
